import { useEffect, useState } from "react";

const refreshes = [
  { id: "ax5", name: "AX5 Data Refresh", date: "10/19/2026", startsAt: new Date(2026, 9, 19), accent: "mint" },
  { id: "pp1", name: "PP1 Data Refresh", date: "11/02/2026", startsAt: new Date(2026, 10, 2), accent: "amber" },
];

const DAY_MS = 24 * 60 * 60 * 1000;

// A refresh is done at its endsAt, or at the end of its start day when no end is set.
export function isRefreshDone(refresh, now) {
  const endsAt = refresh.endsAt || new Date(refresh.startsAt.getTime() + DAY_MS);
  return now >= endsAt.getTime();
}

function getCountdown(target, now) {
  const totalSeconds = Math.max(0, Math.floor((target.getTime() - now) / 1000));
  return {
    totalSeconds,
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor((totalSeconds % 86400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  };
}

function pad(value) {
  return String(value).padStart(2, "0");
}

export default function DataRefreshCountdown({ schedule = refreshes }) {
  const [now, setNow] = useState(Date.now());
  const activeRefreshes = schedule.filter((refresh) => !isRefreshDone(refresh, now));

  useEffect(() => {
    const interval = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(interval);
  }, []);

  if (!activeRefreshes.length) return null;

  return <section className="refresh-section" aria-label="Upcoming data refreshes">
    <div className="refresh-heading"><div><span className="eyebrow">UPCOMING SCHEDULE</span><h2>Database refresh activity</h2></div><span className="refresh-live"><i /> LIVE COUNTDOWN</span></div>
    <div className="refresh-grid">{activeRefreshes.map((refresh) => {
      const countdown = getCountdown(refresh.startsAt, now);
      return <article className={`refresh-card refresh-${refresh.accent}`} key={refresh.id}>
        <div className="refresh-card-heading"><div><h3>{refresh.name}</h3><time dateTime={refresh.startsAt.toISOString()}>{refresh.date}</time></div><span className="refresh-state">{countdown.totalSeconds > 0 ? "STARTS IN" : "IN PROGRESS"}</span></div>
        <div className="refresh-timer" aria-label={`${countdown.days} days, ${countdown.hours} hours, ${countdown.minutes} minutes, ${countdown.seconds} seconds`}>
          <div><strong>{pad(countdown.days)}</strong><span>Days</span></div><b>:</b>
          <div><strong>{pad(countdown.hours)}</strong><span>Hours</span></div><b>:</b>
          <div><strong>{pad(countdown.minutes)}</strong><span>Minutes</span></div><b>:</b>
          <div><strong>{pad(countdown.seconds)}</strong><span>Seconds</span></div>
        </div>
      </article>;
    })}</div>
    <p className="refresh-time-note">Countdowns use your device’s local time.</p>
  </section>;
}